export const getNextVisOrder = (categories, parentId = null) => {
  let siblings = [];

  if (!parentId) {
    siblings = categories;
  } else {
    const findCategory = (items) => {
      for (const item of items) {
        if (item.id === parentId) return item;

        const found = findCategory(item.children || []);
        if (found) return found;
      }

      return null;
    };

    const parent = findCategory(categories);
    siblings = parent?.children || [];
  }

  const maxVisOrder = siblings.reduce((max, item) => {
    const visOrder = Number(item.visOrder) || 0;
    return Math.max(max, visOrder);
  }, 0);

  return maxVisOrder + 1;
};
